const lotusdew = {
    title: "Investment Infrastructure Analyst Intern",
    company: "LotusDew Wealth and Investment Advisors",
    period: "May 2022 - March 2023",
    description: "High Frequency Trading pipeline on Xilinx FPGAs."
  };
  
  export default lotusdew;
  